import os from 'os';
import { ErrorReporter } from '@zg-rentals/particles-js';

export function initErrorReporter() {
    // ErrorReporter is a singleton, sets the options for all server usage of ErrorReporter
    ErrorReporter.set({
        appName: 'rental-manager-web',
        serverName: os.hostname(),
        appVersion: __BUILD_NUMBER__,
        logger: log,
        apiKey: 'BwaC6tSLymqavq4s-g0eWw',
    });
}

export function reportServerError({
    errorLocation,
    errorClass,
    error,
    req,
}) {
    // ZG_ENV should only be production in production deploys.
    // see tools/environments
    if (__PRODUCTION__) {
        ErrorReporter.report({
            errorLocation,
            errorClass,
            error,
            req,
        });
    } else {
        global.TEMPORARY_global_logger.error(`[ZG_ENV: ${process.env.ZG_ENV}]: skipped reporting error:`, {
            errorLocation,
            errorClass,
            error: error.message,
        });
    }
}
